__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ad-astra";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "5.6.1", () => (() => (__webpack_require__(68494))), 1);
			register("@astra-ad/ad-uikit", "1.0.438", () => (() => (__webpack_require__(60568))), 1);
			register("@hookform/resolvers", "2.9.11", () => (() => (__webpack_require__(76912))), 1);
			register("@tanstack/react-query", "4.36.1", () => (() => (__webpack_require__(99462))), 1);
			register("antd", "5.25.4", () => (() => (__webpack_require__(41493))), 1);
			register("axios", "1.9.0", () => (() => (__webpack_require__(32671))), 1);
			register("classnames", "2.3.1", () => (() => (__webpack_require__(524))), 1);
			register("i18next-browser-languagedetector", "6.1.2", () => (() => (__webpack_require__(21425))), 1);
			register("i18next-http-backend", "1.3.1", () => (() => (__webpack_require__(44769))), 1);
			register("i18next", "21.5.4", () => (() => (__webpack_require__(41920))), 1);
			register("mobx-react", "7.2.1", () => (() => (__webpack_require__(20307))), 1);
			register("mobx", "6.3.8", () => (() => (__webpack_require__(9048))), 1);
			register("react-hook-form", "7.56.4", () => (() => (__webpack_require__(49785))), 1);
			register("react-i18next", "11.15.1", () => (() => (__webpack_require__(44009))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(85362))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(23551))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};